export default "/static/images/build_roof_6.png?c1eff1adc8f5a9cf28866bd5e7d70d34";